﻿window.cObjetCentraleReservationFermetureMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Centrale réservation fermeture"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvel centrale réservation fermeture"; }
    this.mGetLib1 = function (option) {
        return "Réservation centrale"
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-door-closed'></i>");
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (!option) option = {}

        var contentMiseEnForme = contentElement
        if (contentElement.closest(".divtemplate").length > 0) {
            contentMiseEnForme = contentElement.closest(".divtemplate")
        }
        contentMiseEnForme.addClass("centrale_fermeture")

        var dataCentraleReservation = objet.bddRef.getObjet("centrale_reservation", dataTemplate.id_centrale_reservation).data
        var dataHebergement = objet.bddRef.getObjet("hebergement", dataTemplate.id_hebergement).data
        var txtIcone = "<i class='fas fa-door-closed'></i> &bull; FERMETURE &bull; " + mGetLibNuites(dataTemplate.date_debut, dataTemplate.date_fin) + "<br/>" + dataTemplate.nom
        $("<div style='white-space:normal;font-size:100%;'/>").appendTo(contentElement).html(txtIcone)

        contentElement.attr("title", contentElement.html())
    }

    this.mShowPopup = function() {
        $("<div/>").appendTo("body").dxCtrlCentraleReservationFermeture({
            bddCtrl: objet.bddRef,
            dataCentraleReservationFermeture: objet.bddRef.getObjet("centrale_reservation_fermeture", objet.data.id_centrale_reservation_fermeture).data
        })
    }

}